import { ThemeEnum } from './enums/theme-enum';

const THEME_KEY = '__THEME__';

export function validateTheme(value: ThemeEnum | string | null) {
  return (
    Object.values(ThemeEnum).find(theme => theme === value) ?? ThemeEnum.LIGTH
  );
}

export function getCurrentTheme(): ThemeEnum {
  return validateTheme(localStorage.getItem(THEME_KEY));
}

export function saveCurrentTheme(theme: ThemeEnum) {
  localStorage.setItem(THEME_KEY, validateTheme(theme));
}

export function isDarkMode(theme?: ThemeEnum) {
  return theme === ThemeEnum.DARK;
}

export function getMatchMediaDark() {
  return window?.matchMedia?.('(prefers-color-scheme: dark)');
}

export function getSystemTheme() {
  return getMatchMediaDark()?.matches ? ThemeEnum.DARK : ThemeEnum.LIGTH;
}
